// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AbstractViewModel } from '@front/webmobile/ViewModels/AbstractViewModel';
import { QuickTable } from '../elements/QuickTable/QuickTable';
import { KeyEventProcessor } from '@shared/commons/KeyEventProcessor';
import { RactiveTooltip } from '../misc/Decorators';
import { ThemeManager } from '../misc/ThemeManager';
import { ErrorInformationStorage } from '@shared/commons/ErrorInformationStorage';
import { ControlsUtils } from '../UtilsClasses/ControlsUtils';
export class QuickTableReactComponentView {
}
export class QuickTableReactViewModel extends AbstractViewModel {
    get tableBackColor() {
        return this.componentView.tableBackColor;
    }
    set tableBackColor(value) {
        this.updateComponentView('tableBackColor', value);
    }
    get currentCursor() {
        return this.componentView.currentCursor;
    }
    set currentCursor(value) {
        this.updateComponentView('currentCursor', value);
    }
    get width() {
        return this.componentView.width;
    }
    set width(value) {
        this.updateComponentView('width', value);
        this.quickTable.width = value;
        if (value !== 0 && this.prevWidth !== value) {
            this.prevWidth = value;
            this.removeEditableControl();
        }
    }
    get height() {
        return this.componentView.height;
    }
    set height(value) {
        this.updateComponentView('height', value);
        this.quickTable.height = value;
        if (value !== 0 && this.prevHeight !== value) {
            this.prevHeight = value;
            this.removeEditableControl();
        }
    }
    constructor(componentView) {
        super(componentView);
        this.ttRowNumber = -1;
        this.ttColNumber = -1;
        this.prevWidth = 0;
        this.prevHeight = 0;
        this.onEditingResult = this.onEditingResult.bind(this);
        this.draw = this.draw.bind(this);
    }
    initialize(props) {
        super.initialize(props);
        this.props = props;
        const keyProc = KeyEventProcessor;
        keyProc.OnKeyDown.Subscribe(this.onGlobalKeyDown, this);
        keyProc.OnKeyUp.Subscribe(this.onGlobalKeyUp, this);
        props.quickTableReactActions.subscribeOnDrawQuickTable(this.draw);
    }
    update(props, prevProps) {
        super.update(props, prevProps);
        this.props = props;
    }
    dispose() {
        if (!isNullOrUndefined(this.quickTable)) {
            this.quickTable.OnShowTooltip.UnSubscribe(this.onShowTooltip, this);
            this.quickTable.Dispose();
        }
        const keyProc = KeyEventProcessor;
        keyProc.OnKeyDown.UnSubscribe(this.onGlobalKeyDown, this);
        keyProc.OnKeyUp.UnSubscribe(this.onGlobalKeyUp, this);
        this.props.quickTableReactActions.unsubscribeOnDrawQuickTable(this.draw);
        super.dispose();
    }
    createQuickTable(context) {
        this.quickTable = this.getNewQuickTable(context);
        this.props.quickTableReactActions.onQuickTableCreated(this.quickTable);
    }
    onExternalCellEditRequest(data) {
        // if (isNullOrUndefined(data)) return;
        // const cell = data.cell;
        // if (isNullOrUndefined(cell)) return;
        // const qtEditingInfo = cell.QuickTableEditingInfo;
        // if (isNullOrUndefined(qtEditingInfo)) return;
        // const absoluteLocation = ControlsUtils.getAbsoluteLocation(this);
        // const cellRect = this.quickTable.getCellRectangleRelativeToCanvas(data.row, data.columnIndex);
        // const controlRect = new Rectangle(
        //     absoluteLocation.X + cellRect.X,
        //     absoluteLocation.Y + cellRect.Y,
        //     cellRect.Width,
        //     cellRect.Height);
        // switch (qtEditingInfo.ControlType) {
        // case DynProperty.DOUBLE:
        //     data.control = new QuickTableNumeric(null, data, this.onEditingResult, controlRect);
        //     break;
        // case DynProperty.COMBOBOX:
        //     data.control = new QuickTableComboBox(null, data, this.onEditingResult, controlRect);
        //     break;
        // case DynProperty.COMBOBOX_COMBOITEM_TIF:
        //     data.control = new QuickTableTifComboBox(null, data, this.onEditingResult, controlRect);
        //     break;
        // case DynProperty.ACCOUNT:{
        //     const IsOnlyOwnAccounts = AccountMenuItemsHelper.GetDataToFillOut(null).IsOnlyOwnAccounts;
        //     if (IsOnlyOwnAccounts) {
        //         data.control = new QuickTableAccountsComboBox(null, data, this.onEditingResult, controlRect);
        //     } else {
        //         data.control = new QuickTableAccountLookup(null, data, this.onEditingResult, controlRect);
        //     }
        //     break;
        // }
        // case DynProperty.INSTRUMENT:
        //     data.control = new QuickTableInstrumentLookup(null, data, this.onEditingResult, controlRect);
        //     break;
        // case DynProperty.COLOR:
        //     ColorPickerScreen.ShowScreen(controlRect.X, controlRect.Y, data.cell.value, (color) => { this.onEditingResult(color, data); });
        //     break;
        // }
        // if (!isNullOrUndefined(data.control)) {
        //     this.quickTable.isActiveEditControl = true;
        //     MainWindowManager.CurrentMainWindow.Controls.quickTableControlContainer.addControl(data.control);
        // }
    }
    removeEditableControl() {
        // if (!this.quickTable.isActiveEditControl) {
        //     return;
        // }
        // MainWindowManager.CurrentMainWindow.Controls.quickTableControlContainer.removeActiveControl();
        // MainWindowManager.CurrentMainWindow.Controls.quickTableControlContainer.removeParentActiveControl();
        // MainWindowManager.CurrentMainWindow.Controls.quickTableControlContainer.removeAllControls();
        // this.setFocus();
        // this.quickTable.isActiveEditControl = false;
    }
    // TODO. Duplicate of RactiveTooltip.decorator = function (node, text).
    // public onExternalShowTooltipRequest (tooltipKey: string, rowNumber: number = -1, colNumber: number = -1): void {
    //     const samePosition = (rowNumber !== -1 && this.ttRowNumber === rowNumber) && (colNumber !== -1 && this.ttColNumber === colNumber);
    //     this.ttRowNumber = rowNumber;
    //     this.ttColNumber = colNumber;
    //     if (isValidString(tooltipKey) && this.tooltipKey === tooltipKey && samePosition) {
    //         return;
    //     }
    //     this.tooltipKey = tooltipKey;
    //     clearTimeout(this.lastShowTooltipTimeoutId);
    //     RactiveTooltip.setTooltipVisibility(false);
    //     if (!WDSettings.tooltips || !isValidString(tooltipKey)) {
    //         return;
    //     }
    //     this.lastShowTooltipTimeoutId = setTimeout(function (tooltipKey) {
    //         RactiveTooltip.showTooltip(tooltipKey);
    //     }, 500, tooltipKey);
    // }
    onEditingResult(value, data) {
        if (!isNullOrUndefined(value)) {
            this.quickTable.afterExternalCellEdit(value, data);
        }
        this.removeEditableControl();
    }
    onResizeBegin() {
        this.quickTable.onResizeBegin();
    }
    onResizeEnd() {
        this.quickTable.onResizeEnd();
    }
    setSizes(w, h) {
        this.width = w;
        this.height = h;
        this.quickTable.onResize();
    }
    resetSizes() {
        this.setSizes(0, 0);
    }
    setContextScale(devicePixelRatio) {
        this.quickTable.context.scale(devicePixelRatio, devicePixelRatio);
    }
    // public setBounds (x: number, y: number, width: number, height: number): void {
    //     if (this.quickTable.lazyResizing) {
    //         super.setBounds(x, y, width, height);
    //     } else {
    //         // Save image before resize and draw it after to avoid flickering (for goo performance)
    //         // var imgD = this.quickTable.context.getImageData(0, 0, this.quickTable.context.canvas.width - 1, this.quickTable.context.canvas.height - 1);
    //         super.setBounds(x, y, width, height);
    //         // this.quickTable.context.putImageData(imgD, 0, 0);
    //         this.quickTable.needRedrawBackground = true;
    //         this.quickTable.needRedraw = true;
    //     }
    // }
    onClick(event) {
        const result = this.quickTable.onMouseClick(event.nativeEvent);
        if (!isNullOrUndefined(this.props.quickTableReactActions.onClick)) {
            this.props.quickTableReactActions.onClick(event);
        }
        if (result) {
            event.stopPropagation();
        }
    }
    onMouseDown(event) {
        this.quickTable.onMouseDown(event.nativeEvent);
        if (!isNullOrUndefined(this.props.quickTableReactActions.onMouseDown)) {
            this.props.quickTableReactActions.onMouseDown(event);
        }
        ControlsUtils.Capture.SetCapture(this, event.nativeEvent);
        event.preventDefault();
    }
    onMouseMove(event) {
        var _a, _b;
        const nativeEvent = (_b = (_a = event.nativeEvent) !== null && _a !== void 0 ? _a : event.originalEvent) !== null && _b !== void 0 ? _b : event;
        this.quickTable.onMouseMove(nativeEvent);
        this.currentCursor = this.quickTable.currentCursor;
    }
    onMouseLeave(event) {
        this.quickTable.onMouseLeave(event.nativeEvent);
    }
    onMouseUp(event) {
        var _a, _b;
        const nativeEvent = (_b = (_a = event.nativeEvent) !== null && _a !== void 0 ? _a : event.originalEvent) !== null && _b !== void 0 ? _b : event;
        this.quickTable.onMouseUp(nativeEvent);
        this.currentCursor = this.quickTable.currentCursor;
    }
    onMouseWheel(event) {
        this.quickTable.onMouseWheel(event.nativeEvent);
    }
    onDoubleClick(event) {
        const isProcessed = this.quickTable.onDoubleClick(event.nativeEvent);
        if (!isProcessed) {
            return;
        }
        this.props.quickTableReactActions.onDoubleClick(event);
    }
    onGlobalKeyDown() {
        // if (!this.get('focused')) return;
        this.quickTable.onKeyDown();
        if (!isNullOrUndefined(this.props.quickTableReactActions.onKeyDown)) {
            this.props.quickTableReactActions.onKeyDown();
        }
    }
    onGlobalKeyUp() {
        // if (!this.get('focused')) return;
        this.quickTable.onKeyUp();
    }
    onShowTooltip(tooltip) {
        RactiveTooltip.showTooltip(tooltip);
    }
    themeChange() {
        if (!isNullOrUndefined(this.quickTable)) {
            this.quickTable.themeChange();
        }
        this.tableBackColor = ThemeManager.colors.attachedQuickTableBackColor;
    }
    draw() {
        this.quickTable.Draw();
    }
    redraw() {
        this.quickTable.redraw();
    }
    getNewQuickTable(context) {
        let quickTable;
        try {
            quickTable = new QuickTable(context, this.props.isAttached);
            quickTable.OnShowTooltip.Subscribe(this.onShowTooltip, this);
            quickTable.OnExternalCellEditRequest.Subscribe(this.onExternalCellEditRequest, this);
            // TODO. Wrong concept.
            // quickTable.OnExternalShowTooltipRequest.Subscribe(this.onExternalShowTooltipRequest, this);
            quickTable.scroll.OnValueChange.Subscribe(this.onQuickTableScroll, this);
            this.themeChange();
        }
        catch (ex) {
            ErrorInformationStorage.GetException(ex);
            quickTable = new QuickTable(null, this.props.isAttached);
        }
        return quickTable;
    }
    onQuickTableScroll() {
        // const controls = MainWindowManager.CurrentMainWindow.Controls.quickTableControlContainer.Controls;
        // if (!isNullOrUndefined(controls) && this.quickTable.isActiveEditControl) {
        //     for (const _guid in controls) {
        //         const control = controls[_guid];
        //         control?.lostFocus();
        //     }
        // }
        this.removeEditableControl();
    }
}
